import { Molecule, wrap } from 'AppReact';
import { Mr1 } from 'wrappers';
import styled, { css } from 'styled-components';
import { HomeSvg } from 'components/icons';
import { Icon, WhiteTextXs } from 'atoms';

const template = styled.div`
  ${({ theme }) => css`
    padding: 2px 6px;
    display: flex;
    align-items: center;
    border-radius: 20px;
    background: ${theme?.colour?.primary ?? '#1DBD6B'};
    font-size: 12px;
    color: #FFFFFF,
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    @media only screen and (min-width: 768px) {
      padding: 4px 8px;
    }
  `}
`;


export default Molecule({
  template,
  atoms: [
    {
      component: wrap(WhiteTextXs, Mr1),
      name: 'Count',
      displayValue: ({ count }) => `${count} `,
    },
    {
      component: Icon,
      name: 'Icon',
      renderIf: ({ group }) => group,
      displayValue: ({ }) => HomeSvg({ multiple: true, width: 16, height: 13, color: '#FFFFFF' })
    },
    {
      component: Icon,
      name: 'Icon',
      renderIf: ({ group }) => !group,
      displayValue: ({ }) => HomeSvg({ width: 13, height: 13, color: '#FFFFFF' })
    },

  ]
})